"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDownCircle = _interopRequireDefault(require("./IconArrowDownCircle"));
var IconArrowRightCircle = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDownCircle.default).withConfig({
  displayName: "IconArrowRightCircle",
  componentId: "c11n-8-107-0__sc-zffocw-0"
})(["transform:rotate(270deg);"]);
var _default = IconArrowRightCircle;
exports.default = _default;